export default {
  "fr": {
    "tenant": {
      "actions": {
        "changeCompanyLogo": "Changer le logo (png requis)"
      },
      "picture_logo_format": {
        "round": "Logo rond",
        "square": "Logo carré"
      }
    }
  }
}